import userAPIs from "./APIs/user-apis";
import paymentAPIs from "./APIs/payment-apis";
import termAPIs from "./APIs/term-apis";

var apis = {
  user: userAPIs,
  payment: paymentAPIs,
  term: termAPIs,
};

export default apis;
